<template>
  <div class="c-dashboard__card">
    <b-card>
      <b-card-title>
        {{ $t("lang.label_certificate_auditLog") }}<small class="text-body">({{ $t("lang.label_user_newest_event") }})</small>
      </b-card-title>
      <b-table responsive="sm" :items="audits" :fields="fields"> </b-table>
    </b-card>
  </div>
</template>
<script>
import API from "../../api";
import moment from "moment";
import * as utils from "@/utils";
export default {
  name: "ViewLatestAuditsForUser",
  data() {
    return {
      fields: [
        {
          key: "eventDescription",
          label: this.$t("lang.label_certificate_audit_event_description"),
          formatter(value) {
            var activity = value.split(":");
            return utils.toCamelCase(activity[0]).concat(activity[1]);
          },
          tdClass: "break-text-all"
        },
        {
          key: "occurredDate",
          label: this.$t("lang.label_certificate_audit_event_date"),
          formatter(value) {
            return moment(String(value)).format(utils.constants.DATE_TIME_PATTERN);
          }
        }
      ],
      audits: []
    };
  },
  methods: {
    getUserAudits() {
      API.getAuditsForUser()
        .then(response => {
          this.audits = response.data;
        })
        .catch(() => {});
    }
  },
  created() {
    this.getUserAudits();
  }
};
</script>
<style></style>
